import React, { useState } from 'react';
import ChatBox from '../pages/experts/Connections/ChatBox';
import { useSelector } from 'react-redux';
import { useData } from '../data';
import AdvertMessage from '../pages/experts/Connections/AdvertMessage';
import ConnectionMessage from '../pages/experts/Connections/ConnectionMessage';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { Box, Flex, Text } from '@chakra-ui/react';
import StyledSpinner from './spinner/Spinner';

const ChatMessageWidget = ({
  requestListIsOpen,
  isDesktop,
  connections,
  setConnections,
  refetchConnections,
  connectionsLoading,
  sortFn,
  recipient,
  setRecipient,
  recipientId,
  selectedAdvert,
  advertId,
  isAdvert,
  isFromNavigate,
  openChatBox,
  openAdvert,
  closeChatBox,
  chatBoxIsOpen,
}) => {
  const userDetails = useSelector((state) => state?.user?.userInfo);
  const [showMessageTray, setShowMessageTray] = useState(false);

  const {
    data: inboxAdverts,
    isLoading: inboxAdvertsLoading,
    refetch: refetchInboxAdverts,
  } = useData(`inbox-adverts/`);

  const openMessageTray = () => {
    if (userDetails?.status == 'disabled') return;
    setShowMessageTray((prev) => !prev);
  };

  return (
    <>
      {!requestListIsOpen ? (
        <Flex
          hidden={isDesktop ? false : true}
          className="fixed hidden items-end min-w-max right-10 gap-8 z-10 bottom-0"
        >
          <Flex
            className="bg-white"
            boxShadow="0px 10px 20px rgba(0, 0, 0, 0.05)"
          >
            {chatBoxIsOpen && (
              <Box w={'480px'} h="80vh max-h-[300px]">
                <ChatBox
                  advert={selectedAdvert}
                  advertId={advertId}
                  isAdvert={isAdvert}
                  isFromNavigate={isFromNavigate}
                  recipientId={recipientId}
                  setRecipient={setRecipient}
                  recipient={recipient}
                  closeChatBox={closeChatBox}
                  refetchConnections={refetchConnections}
                  setConnections={setConnections}
                />
              </Box>
            )}
          </Flex>
          <Flex
            boxShadow="0px 10px 20px rgba(0, 0, 0, 0.05)"
            className="flex-col bg-white min-w-[300px] rounded-t-md z-10"
          >
            <Flex
              bgColor="#134A70"
              className="items-center justify-between py-2 px-3 rounded-t-md cursor-pointer"
              onClick={openMessageTray}
            >
              <Text
                fontSize={{ base: 14 }}
                fontWeight={800}
                ml={{ base: '3rem', lg: 0 }}
                color="#fff"
              >
                New Conversation
              </Text>
              <Box>
                {showMessageTray ? (
                  <ChevronDownIcon w={7} h={7} color="white" />
                ) : (
                  <ChevronUpIcon w={7} h={7} color="white" />
                )}
              </Box>
            </Flex>
            <Box className="max-h-[60vh] overflow-y-auto">
              {showMessageTray ? (
                connectionsLoading ? (
                  <StyledSpinner />
                ) : (
                  <>
                    {[...(inboxAdverts?.data?.adverts || []), ...connections]
                      ?.length > 0 ? (
                      [
                        ...(inboxAdverts?.data?.adverts || []),
                        ...connections.filter((b) => b.accepted === true),
                      ]
                        ?.sort(sortFn)
                        ?.map((connection, index) =>
                          connection?.advert_type ? (
                            <AdvertMessage
                              advert={connection}
                              key={index}
                              openChatBox={openAdvert}
                            />
                          ) : (
                            <ConnectionMessage
                              recipient={connection}
                              key={index}
                              openChatBox={openChatBox}
                            />
                          ),
                        )
                    ) : (
                      <Box className="text-center">No connections...</Box>
                    )}
                  </>
                )
              ) : (
                <Box py={1}></Box>
              )}
            </Box>
          </Flex>
        </Flex>
      ) : null}
    </>
  );
};

export default ChatMessageWidget;
